// TEAM OS HUB — i18n strings for F4 frontend (Feb 2026).
// Used by HubAppSwitcher, MyAppsSettings and OnboardingWizard. EN/ES
// complete; other locales fall back to EN automatically.

const pick = (m, lang) => m[lang] ?? m.en;

const _COPY = (lang) => ({
  // ---- HubAppSwitcher (navbar dropdown)
  switcherTrigger: pick({ en: "My apps", es: "Mis apps", ca: "Les meves aplicacions", eu: "Nire aplikazioak", gl: "As miñas apps", ar: "تطبيقاتي", he: "האפליקציות שלי", zh: "我的应用", it: "Le mie app", fr: "Mes applications", de: "Meine Apps", "pt-br": "Meus aplicativos", ja: "マイアプリ", hi: "मेरे ऐप्स", ko: "내 앱", ru: "Мои приложения", cs: "Moje aplikace", nl: "Mijn apps", }, lang),
  switcherTitle: pick({ en: "Your active apps", es: "Tus apps activas", ca: "Les teves aplicacions actives", eu: "Zure aplikazio aktiboak", gl: "As túas apps activas", ar: "تطبيقاتك النشطة", he: "האפליקציות הפעילות שלך", zh: "您的活跃应用", it: "Le tue app attive", fr: "Vos applications actives", de: "Ihre aktiven Apps", "pt-br": "Seus aplicativos ativos", ja: "有効なアプリ", hi: "आपके सक्रिय ऐप्स", ko: "활성화된 앱", ru: "Ваши активные приложения", cs: "Vaše aktivní aplikace", nl: "Je actieve apps", }, lang),
  switcherEmpty: pick({
    en: "You don't have any active apps yet.",
    es: "Aún no tienes apps activas.",
    ca: "Encara no tens cap aplicació activa.",
    eu: "Ez duzu oraindik aplikazio aktiborik.",
    gl: "Aínda non tes ningunha app activa.",
    ar: "ليس لديك أي تطبيقات نشطة بعد.",
    he: "אין לך עדיין אפליקציות פעילות.",
    zh: "您还没有任何活跃应用。",
    it: "Non hai ancora app attive.",
    fr: "Vous n'avez pas encore d'applications actives.",
    de: "Sie haben noch keine aktiven Apps.",
    "pt-br": "Você ainda não tem aplicativos ativos.",
    ja: "まだ有効なアプリがありません。",
    hi: "आपके पास अभी तक कोई सक्रिय ऐप नहीं है।",
    ko: "아직 활성화된 앱이 없습니다.",
    ru: "У вас пока нет активных приложений.",
    cs: "Zatím nemáte žádné aktivní aplikace.",
    nl: "Je hebt nog geen actieve apps.",
  }, lang),
  exploreMore: pick({ en: "Explore more apps", es: "Explorar más apps", ca: "Explora més aplicacions", eu: "Arakatu aplikazio gehiago", gl: "Explorar máis apps", ar: "استكشف المزيد من التطبيقات", he: "חקור אפליקציות נוספות", zh: "探索更多应用", it: "Esplora altre app", fr: "Découvrir plus d'applications", de: "Weitere Apps entdecken", "pt-br": "Explorar mais aplicativos", ja: "他のアプリを見る", hi: "अधिक ऐप्स देखें", ko: "더 많은 앱 둘러보기", ru: "Найти ещё приложения", cs: "Prozkoumat další aplikace", nl: "Ontdek meer apps", }, lang),
  manageMyApps: pick({ en: "Manage my apps", es: "Gestionar mis apps", ca: "Gestiona les meves aplicacions", eu: "Kudeatu nire aplikazioak", gl: "Xestionar as miñas apps", ar: "إدارة تطبيقاتي", he: "נהל את האפליקציות שלי", zh: "管理我的应用", it: "Gestisci le mie app", fr: "Gérer mes applications", de: "Meine Apps verwalten", "pt-br": "Gerenciar meus aplicativos", ja: "マイアプリを管理", hi: "मेरे ऐप्स प्रबंधित करें", ko: "내 앱 관리", ru: "Управлять приложениями", cs: "Spravovat moje aplikace", nl: "Beheer mijn apps", }, lang),

  // ---- /app/settings/apps page
  settingsPageTitle: pick({ en: "My HUB apps", es: "Mis apps HUB", ca: "Les meves aplicacions de HUB", eu: "Nire HUB aplikazioak", gl: "As miñas apps HUB", ar: "تطبيقات HUB الخاصة بي", he: "אפליקציות ה-HUB שלי", zh: "我的 HUB 应用", it: "Le mie app HUB", fr: "Mes applications HUB", de: "Meine HUB-Apps", "pt-br": "Meus aplicativos HUB", ja: "マイHUBアプリ", hi: "मेरे HUB ऐप्स", ko: "내 HUB 앱", ru: "Мои приложения HUB", cs: "Moje HUB aplikace", nl: "Mijn HUB-apps", }, lang),
  settingsPageSub: pick({
    en: "Manage which apps you use across TEAM OS HUB.",
    es: "Gestiona qué apps usas en TEAM OS HUB.",
    ca: "Gestiona quines aplicacions utilitzes a TEAM OS HUB.",
    eu: "Kudeatu TEAM OS HUB-en zehar erabiltzen dituzun aplikazioak.",
    gl: "Xestiona que apps usas en TEAM OS HUB.",
    ar: "إدارة التطبيقات التي تستخدمها عبر TEAM OS HUB.",
    he: "נהל אילו אפליקציות אתה משתמש במערכת TEAM OS HUB.",
    zh: "管理您在 TEAM OS HUB 中使用的应用。",
    it: "Gestisci quali app utilizzi su TEAM OS HUB.",
    fr: "Gérez les applications que vous utilisez dans TEAM OS HUB.",
    de: "Verwalten Sie, welche Apps Sie im TEAM OS HUB verwenden.",
    "pt-br": "Gerencie quais aplicativos você usa no TEAM OS HUB.",
    ja: "TEAM OS HUBで使用するアプリを管理します。",
    hi: "TEAM OS HUB में उपयोग किए जाने वाले ऐप्स प्रबंधित करें।",
    ko: "TEAM OS HUB에서 사용하는 앱을 관리하세요.",
    ru: "Управляйте приложениями, которые вы используете в TEAM OS HUB.",
    cs: "Spravujte, které aplikace používáte v rámci TEAM OS HUB.",
    nl: "Beheer welke apps je gebruikt in TEAM OS HUB.",
  }, lang),
  tabActive: pick({ en: "Active", es: "Activas", ca: "Activa", eu: "Aktiboa", gl: "Activa", ar: "نشط", he: "פעיל", zh: "活跃", it: "Attiva", fr: "Active", de: "Aktiv", "pt-br": "Ativo", ja: "有効", hi: "सक्रिय", ko: "활성", ru: "Активно", cs: "Aktivní", nl: "Actief", }, lang),
  tabAvailable: pick({ en: "Available", es: "Disponibles", ca: "Disponible", eu: "Erabilgarria", gl: "Dispoñible", ar: "متاح", he: "זמין", zh: "可用", it: "Disponibile", fr: "Disponible", de: "Verfügbar", "pt-br": "Disponível", ja: "利用可能", hi: "उपलब्ध", ko: "사용 가능", ru: "Доступно", cs: "Dostupné", nl: "Beschikbaar", }, lang),

  // ---- Membership status labels
  statusActive: pick({ en: "Active", es: "Activa", ca: "Activa", eu: "Aktiboa", gl: "Activa", ar: "نشط", he: "פעיל", zh: "活跃", it: "Attiva", fr: "Active", de: "Aktiv", "pt-br": "Ativo", ja: "有効", hi: "सक्रिय", ko: "활성", ru: "Активно", cs: "Aktivní", nl: "Actief", }, lang),
  statusPending: pick({ en: "Setup pending", es: "Configuración pendiente", ca: "Configuració pending", eu: "Konfigurazioa egiteko", gl: "Configuración pendente", ar: "الإعداد معلق", he: "ממתין להגדרה", zh: "待设置", it: "Configurazione in sospeso", fr: "Configuration en attente", de: "Einrichtung ausstehend", "pt-br": "Configuração pendente", ja: "設定待ち", hi: "सेटअप लंबित", ko: "설정 대기 중", ru: "Настройка не завершена", cs: "Čeká na nastavení", nl: "Configuratie in behandeling", }, lang),
  statusSuspended: pick({ en: "Suspended", es: "Suspendida", ca: "Suspesa", eu: "Etendako", gl: "Suspendida", ar: "معلق", he: "מושעה", zh: "已暂停", it: "Sospesa", fr: "Suspendue", de: "Ausgesetzt", "pt-br": "Suspenso", ja: "一時停止", hi: "निलंबित", ko: "일시 중지됨", ru: "Приостановлено", cs: "Pozastaveno", nl: "Geschorst", }, lang),
  statusRevoked: pick({ en: "Revoked", es: "Revocada", ca: "Revocada", eu: "Indargabetua", gl: "Revogada", ar: "ملغى", he: "בוטל", zh: "已撤销", it: "Revocata", fr: "Révoquée", de: "Widerrufen", "pt-br": "Revogado", ja: "取り消し済み", hi: "निरस्त", ko: "취소됨", ru: "Отозвано", cs: "Zrušeno", nl: "Ingetrokken", }, lang),

  // ---- Card actions
  btnConfigure: pick({ en: "Configure", es: "Configurar", ca: "Configura", eu: "Konfiguratu", gl: "Configurar", ar: "تكوين", he: "הגדר", zh: "配置", it: "Configura", fr: "Configurer", de: "Konfigurieren", "pt-br": "Configurar", ja: "設定", hi: "कॉन्फ़िगर करें", ko: "구성", ru: "Настроить", cs: "Konfigurovat", nl: "Configureren", }, lang),
  btnDeactivate: pick({ en: "Deactivate", es: "Desactivar", ca: "Desactiva", eu: "Desaktibatu", gl: "Desactivar", ar: "إلغاء التنشيط", he: "השבת", zh: "停用", it: "Disattiva", fr: "Désactiver", de: "Deaktivieren", "pt-br": "Desativar", ja: "無効化", hi: "निष्क्रिय करें", ko: "비활성화", ru: "Деактивировать", cs: "Deaktivovat", nl: "Deactiveren", }, lang),
  btnActivate: pick({ en: "Activate", es: "Activar", ca: "Activa", eu: "Aktibatu", gl: "Activar", ar: "تنشيط", he: "הפעל", zh: "激活", it: "Attiva", fr: "Activer", de: "Aktivieren", "pt-br": "Ativar", ja: "有効化", hi: "सक्रिय करें", ko: "활성화", ru: "Активировать", cs: "Aktivovat", nl: "Activeren", }, lang),
  btnReactivate: pick({ en: "Reactivate", es: "Reactivar", ca: "Reactiva", eu: "Berriro aktibatu", gl: "Reactivar", ar: "إعادة التنشيط", he: "הפעל מחדש", zh: "重新激活", it: "Riattiva", fr: "Réactiver", de: "Reaktivieren", "pt-br": "Reativar", ja: "再有効化", hi: "पुनः सक्रिय करें", ko: "재활성화", ru: "Реактивировать", cs: "Znovu aktivovat", nl: "Heractiveren", }, lang),
  joinedOn: pick({ en: "Joined", es: "Se unió", ca: "Unit", eu: "Batuta", gl: "Unícheste", ar: "منضم", he: "הצטרף", zh: "已加入", it: "Entrato", fr: "Rejoint", de: "Beigetreten", "pt-br": "Associado", ja: "参加済み", hi: "शामिल हुए", ko: "참여함", ru: "Подключено", cs: "Připojeno", nl: "Toegetreden", }, lang),
  completionLabel: pick({ en: "Configured", es: "Configurado", ca: "Configurada", eu: "Konfiguratua", gl: "Configurada", ar: "مُكوَّن", he: "הוגדר", zh: "已配置", it: "Configurata", fr: "Configurée", de: "Konfiguriert", "pt-br": "Configurado", ja: "設定済み", hi: "कॉन्फ़िगर किया गया", ko: "구성됨", ru: "Настроено", cs: "Nakonfigurováno", nl: "Geconfigureerd", }, lang),

  // ---- Confirm dialog
  confirmDeactivateTitle: pick({
    en: "Deactivate this app?",
    es: "¿Desactivar esta app?",
    ca: "Desactivar aquesta aplicació?",
    eu: "Desaktibatu aplikazio hau?",
    gl: "Desactivar esta app?",
    ar: "إلغاء تنشيط هذا التطبيق؟",
    he: "להשבית אפליקציה זו?",
    zh: "停用此应用?",
    it: "Disattivare questa app?",
    fr: "Désactiver cette application ?",
    de: "Diese App deaktivieren?",
    "pt-br": "Desativar este aplicativo?",
    ja: "このアプリを無効化しますか?",
    hi: "इस ऐप को निष्क्रिय करें?",
    ko: "이 앱을 비활성화하시겠습니까?",
    ru: "Деактивировать это приложение?",
    cs: "Deaktivovat tuto aplikaci?",
    nl: "Deze app deactiveren?",
  }, lang),
  confirmDeactivateBody: pick({
    en: "You will lose access until you reactivate it. Your data is preserved.",
    es: "Perderás acceso hasta reactivarla. Tus datos se preservan.",
    ca: "Perdràs l'accés fins que la reactivis. Les teves dades es conserven.",
    eu: "Sarbidea galduko duzu berriro aktibatu arte. Zure datuak gordetzen dira.",
    gl: "Perderás o acceso ata que a reactives. Os teus datos consérvanse.",
    ar: "ستفقد الوصول حتى تقوم بإعادة تنشيطه. بياناتك محفوظة.",
    he: "תאבד גישה עד שתפעיל אותה מחדש. הנתונים שלך נשמרים.",
    zh: "您将失去访问权限,直到重新激活。您的数据将被保留。",
    it: "Perderai l'accesso finché non la riattiverai. I tuoi dati sono conservati.",
    fr: "Vous perdrez l'accès jusqu'à ce que vous la réactiviez. Vos données sont préservées.",
    de: "Sie verlieren den Zugriff, bis Sie sie reaktivieren. Ihre Daten bleiben erhalten.",
    "pt-br": "Você perderá o acesso até reativá-lo. Seus dados serão preservados.",
    ja: "再有効化するまでアクセスできなくなります。データは保持されます。",
    hi: "पुनः सक्रिय करने तक आप एक्सेस खो देंगे। आपका डेटा सुरक्षित रहेगा।",
    ko: "재활성화할 때까지 액세스 권한을 잃게 됩니다. 데이터는 보존됩니다.",
    ru: "Вы потеряете доступ до повторной активации. Ваши данные сохранятся.",
    cs: "Ztratíte přístup, dokud ji znovu neaktivujete. Vaše data zůstanou zachována.",
    nl: "Je verliest toegang totdat je de app heractiveert. Je gegevens blijven behouden.",
  }, lang),
  confirmDeactivateAccept: pick({ en: "Yes, deactivate", es: "Sí, desactivar", ca: "Sí, desactiva", eu: "Bai, desaktibatu", gl: "Si, desactivar", ar: "نعم، إلغاء التنشيط", he: "כן, השבת", zh: "是的,停用", it: "Sì, disattiva", fr: "Oui, désactiver", de: "Ja, deaktivieren", "pt-br": "Sim, desativar", ja: "はい、無効化します", hi: "हाँ, निष्क्रिय करें", ko: "예, 비활성화", ru: "Да, деактивировать", cs: "Ano, deaktivovat", nl: "Ja, deactiveren", }, lang),
  confirmDeactivateCancel: pick({ en: "Cancel", es: "Cancelar", ca: "Cancel·la", eu: "Utzi", gl: "Cancelar", ar: "إلغاء", he: "ביטול", zh: "取消", it: "Annulla", fr: "Annuler", de: "Abbrechen", "pt-br": "Cancelar", ja: "キャンセル", hi: "रद्द करें", ko: "취소", ru: "Отмена", cs: "Zrušit", nl: "Annuleren", }, lang),

  // ---- OnboardingWizard
  wizardTitle: pick({
    en: "Configure {{app}}",
    es: "Configurar {{app}}",
    ca: "Configura {{app}}",
    eu: "Konfiguratu {{app}}",
    gl: "Configurar {{app}}",
    ar: "تكوين {{app}}",
    he: "הגדר את {{app}}",
    zh: "配置 {{app}}",
    it: "Configura {{app}}",
    fr: "Configurer {{app}}",
    de: "{{app}} konfigurieren",
    "pt-br": "Configurar {{app}}",
    ja: "{{app}}を設定",
    hi: "{{app}} कॉन्फ़िगर करें",
    ko: "{{app}} 구성",
    ru: "Настроить {{app}}",
    cs: "Konfigurovat {{app}}",
    nl: "{{app}} configureren",
  }, lang),
  wizardDone: pick({
    en: "You're all set!",
    es: "¡Todo listo!",
    ca: "Ja està tot a punt!",
    eu: "Dena prest!",
    gl: "Todo listo!",
    ar: "أنت جاهز تماماً!",
    he: "הכול מוכן!",
    zh: "一切就绪!",
    it: "Tutto pronto!",
    fr: "Tout est prêt !",
    de: "Alles erledigt!",
    "pt-br": "Tudo pronto!",
    ja: "設定完了です!",
    hi: "आप तैयार हैं!",
    ko: "모두 완료되었습니다!",
    ru: "Всё готово!",
    cs: "Vše je připraveno!",
    nl: "Je bent helemaal klaar!",
  }, lang),
  wizardActivate: pick({ en: "Activate app", es: "Activar app", ca: "Activa l'aplicació", eu: "Aktibatu aplikazioa", gl: "Activar app", ar: "تنشيط التطبيق", he: "הפעל אפליקציה", zh: "激活应用", it: "Attiva app", fr: "Activer l'application", de: "App aktivieren", "pt-br": "Ativar aplicativo", ja: "アプリを有効化", hi: "ऐप सक्रिय करें", ko: "앱 활성화", ru: "Активировать приложение", cs: "Aktivovat aplikaci", nl: "App activeren", }, lang),
  wizardNext: pick({ en: "Next", es: "Siguiente", ca: "Següent", eu: "Hurrengoa", gl: "Seguinte", ar: "التالي", he: "הבא", zh: "下一步", it: "Avanti", fr: "Suivant", de: "Weiter", "pt-br": "Próximo", ja: "次へ", hi: "आगे", ko: "다음", ru: "Далее", cs: "Další", nl: "Volgende", }, lang),
  wizardBack: pick({ en: "Back", es: "Atrás", ca: "Enrere", eu: "Atzera", gl: "Atrás", ar: "رجوع", he: "חזור", zh: "返回", it: "Indietro", fr: "Retour", de: "Zurück", "pt-br": "Voltar", ja: "戻る", hi: "वापस", ko: "뒤로", ru: "Назад", cs: "Zpět", nl: "Terug", }, lang),
  wizardSkipSoft: pick({ en: "Skip this step", es: "Saltar este paso", ca: "Omet aquest pas", eu: "Saltatu urrats hau", gl: "Omitir este paso", ar: "تخطي هذه الخطوة", he: "דלג על שלב זה", zh: "跳过此步骤", it: "Salta questo passaggio", fr: "Passer cette étape", de: "Diesen Schritt überspringen", "pt-br": "Pular esta etapa", ja: "このステップをスキップ", hi: "यह चरण छोड़ें", ko: "이 단계 건너뛰기", ru: "Пропустить этот шаг", cs: "Přeskočit tento krok", nl: "Deze stap overslaan", }, lang),
  wizardSkipOptional: pick({ en: "Skip", es: "Saltar", ca: "Omet", eu: "Saltatu", gl: "Omitir", ar: "تخطي", he: "דלג", zh: "跳过", it: "Salta", fr: "Passer", de: "Überspringen", "pt-br": "Pular", ja: "スキップ", hi: "छोड़ें", ko: "건너뛰기", ru: "Пропустить", cs: "Přeskočit", nl: "Overslaan", }, lang),
  wizardClose: pick({ en: "Close", es: "Cerrar", ca: "Tanca", eu: "Itxi", gl: "Pechar", ar: "إغلاق", he: "סגור", zh: "关闭", it: "Chiudi", fr: "Fermer", de: "Schließen", "pt-br": "Fechar", ja: "閉じる", hi: "बंद करें", ko: "닫기", ru: "Закрыть", cs: "Zavřít", nl: "Sluiten", }, lang),
  wizardRequired: pick({ en: "Required", es: "Obligatorio", ca: "Obligatori", eu: "Beharrezkoa", gl: "Obrigatorio", ar: "مطلوب", he: "חובה", zh: "必填", it: "Obbligatorio", fr: "Requis", de: "Erforderlich", "pt-br": "Obrigatório", ja: "必須", hi: "आवश्यक", ko: "필수", ru: "Обязательно", cs: "Povinné", nl: "Verplicht", }, lang),
  wizardRecommended: pick({ en: "Recommended", es: "Recomendado", ca: "Recomanat", eu: "Gomendatua", gl: "Recomendado", ar: "موصى به", he: "מומלץ", zh: "推荐", it: "Consigliato", fr: "Recommandé", de: "Empfohlen", "pt-br": "Recomendado", ja: "推奨", hi: "अनुशंसित", ko: "권장", ru: "Рекомендуется", cs: "Doporučené", nl: "Aanbevolen", }, lang),
  wizardOptional: pick({ en: "Optional", es: "Opcional", ca: "Opcional", eu: "Aukerakoa", gl: "Opcional", ar: "اختياري", he: "אופציונלי", zh: "可选", it: "Facoltativo", fr: "Facultatif", de: "Optional", "pt-br": "Opcional", ja: "任意", hi: "वैकल्पिक", ko: "선택", ru: "Необязательно", cs: "Volitelné", nl: "Optioneel", }, lang),
  wizardLoading: pick({ en: "Loading…", es: "Cargando…", ca: "Carregant…", eu: "Kargatzen…", gl: "Cargando…", ar: "جارٍ التحميل…", he: "טוען…", zh: "加载中…", it: "Caricamento…", fr: "Chargement…", de: "Wird geladen…", "pt-br": "Carregando…", ja: "読み込み中…", hi: "लोड हो रहा है…", ko: "로딩 중…", ru: "Загрузка…", cs: "Načítání…", nl: "Laden…", }, lang),
  wizardError: pick({
    en: "Could not load setup. Try again later.",
    es: "No se pudo cargar la configuración. Intenta más tarde.",
    ca: "No s'ha pogut carregar la configuració. Torna-ho a provar més tard.",
    eu: "Ezin izan da konfigurazioa kargatu. Saiatu beranduago.",
    gl: "Non se puido cargar a configuración. Téntao máis tarde.",
    ar: "تعذر تحميل الإعداد. حاول مرة أخرى لاحقاً.",
    he: "לא ניתן לטעון את ההגדרות. נסה שוב מאוחר יותר.",
    zh: "无法加载设置。请稍后重试。",
    it: "Impossibile caricare la configurazione. Riprova più tardi.",
    fr: "Impossible de charger la configuration. Réessayez plus tard.",
    de: "Setup konnte nicht geladen werden. Versuchen Sie es später erneut.",
    "pt-br": "Não foi possível carregar a configuração. Tente novamente mais tarde.",
    ja: "セットアップを読み込めませんでした。後でもう一度お試しください。",
    hi: "सेटअप लोड नहीं हो सका। बाद में पुनः प्रयास करें।",
    ko: "설정을 불러올 수 없습니다. 나중에 다시 시도하세요.",
    ru: "Не удалось загрузить настройки. Повторите попытку позже.",
    cs: "Nastavení se nepodařilo načíst. Zkuste to později.",
    nl: "Kon installatie niet laden. Probeer het later opnieuw.",
  }, lang),

  // ---- App key labels (display names)
  appLabels: {
    team_core: pick({ en: "TEAM Core", es: "TEAM Core", ca: "TEAM Core", eu: "TEAM Core", gl: "TEAM Core", ar: "TEAM Core", he: "TEAM Core", zh: "TEAM Core", it: "TEAM Core", fr: "TEAM Core", de: "TEAM Core", "pt-br": "TEAM Core", ja: "TEAM Core", hi: "TEAM Core", ko: "TEAM Core", ru: "TEAM Core", cs: "TEAM Core", nl: "TEAM Core", }, lang),
    racket_lab: pick({ en: "Racket Lab", es: "Racket Lab", ca: "Racket Lab", eu: "Racket Lab", gl: "Racket Lab", ar: "Racket Lab", he: "Racket Lab", zh: "Racket Lab", it: "Racket Lab", fr: "Racket Lab", de: "Racket Lab", "pt-br": "Racket Lab", ja: "Racket Lab", hi: "Racket Lab", ko: "Racket Lab", ru: "Racket Lab", cs: "Racket Lab", nl: "Racket Lab", }, lang),
    marketplace: pick({ en: "Marketplace", es: "Marketplace", ca: "Marketplace", eu: "Marketplace", gl: "Marketplace", ar: "Marketplace", he: "Marketplace", zh: "Marketplace", it: "Marketplace", fr: "Marketplace", de: "Marketplace", "pt-br": "Marketplace", ja: "Marketplace", hi: "Marketplace", ko: "Marketplace", ru: "Marketplace", cs: "Marketplace", nl: "Marketplace", }, lang),
    wlp: pick({ en: "Wishlist Program", es: "Programa Wishlist", ca: "Wishlist Program", eu: "Wishlist Program", gl: "Programa Wishlist", ar: "Wishlist Program", he: "Wishlist Program", zh: "Wishlist Program", it: "Wishlist Program", fr: "Wishlist Program", de: "Wishlist Program", "pt-br": "Programa Wishlist", ja: "Wishlist Program", hi: "Wishlist Program", ko: "Wishlist Program", ru: "Программа пожеланий", cs: "Wishlist Program", nl: "Wishlist Program", }, lang),
    team_tennis: pick({ en: "TEAM Tennis", es: "TEAM Tennis", ca: "TEAM Tennis", eu: "TEAM Tennis", gl: "TEAM Tennis", ar: "TEAM Tennis", he: "TEAM Tennis", zh: "TEAM Tennis", it: "TEAM Tennis", fr: "TEAM Tennis", de: "TEAM Tennis", "pt-br": "TEAM Tennis", ja: "TEAM Tennis", hi: "TEAM Tennis", ko: "TEAM Tennis", ru: "TEAM Tennis", cs: "TEAM Tennis", nl: "TEAM Tennis", }, lang),
    padel: pick({ en: "Padel", es: "Pádel", ca: "Pàdel", eu: "Padel", gl: "Padel", ar: "Padel", he: "Padel", zh: "Padel", it: "Padel", fr: "Padel", de: "Padel", "pt-br": "Padel", ja: "Padel", hi: "Padel", ko: "Padel", ru: "Падел", cs: "Padel", nl: "Padel", }, lang),
    pickleball: pick({ en: "Pickleball", es: "Pickleball", ca: "Pickleball", eu: "Pickleball", gl: "Pickleball", ar: "Pickleball", he: "Pickleball", zh: "Pickleball", it: "Pickleball", fr: "Pickleball", de: "Pickleball", "pt-br": "Pickleball", ja: "Pickleball", hi: "Pickleball", ko: "Pickleball", ru: "Пиклбол", cs: "Pickleball", nl: "Pickleball", }, lang),
  },

  // ---- Field labels (per app, only those used by the wizard today)
  fieldLabels: {
    currency_preference: pick({
      en: "Preferred currency",
      es: "Moneda preferida",
      ca: "Moneda preferida",
      eu: "Hobetsitako moneta",
      gl: "Moeda preferida",
      ar: "العملة المفضلة",
      he: "מטבע מועדף",
      zh: "首选货币",
      it: "Valuta preferita",
      fr: "Devise préférée",
      de: "Bevorzugte Währung",
      "pt-br": "Moeda preferida",
      ja: "希望通貨",
      hi: "पसंदीदा मुद्रा",
      ko: "기본 통화",
      ru: "Предпочитаемая валюта",
      cs: "Preferovaná měna",
      nl: "Voorkeur valuta",
    }, lang),
    marketing_opt_in: pick({
      en: "Receive marketplace notifications",
      es: "Recibir notificaciones del marketplace",
      ca: "Rebre notificacions del marketplace",
      eu: "Jaso marketplace-ko jakinarazpenak",
      gl: "Recibir notificacións do marketplace",
      ar: "تلقي إشعارات السوق",
      he: "קבל התראות מהחנות",
      zh: "接收市场通知",
      it: "Ricevi notifiche del marketplace",
      fr: "Recevoir les notifications marketplace",
      de: "Marketplace-Benachrichtigungen erhalten",
      "pt-br": "Receber notificações do marketplace",
      ja: "マーケットプレイス通知を受け取る",
      hi: "मार्केटप्लेस सूचनाएं प्राप्त करें",
      ko: "마켓플레이스 알림 받기",
      ru: "Получать уведомления о маркетплейсе",
      cs: "Přijímat oznámení z marketplace",
      nl: "Marketplace-meldingen ontvangen",
    }, lang),
    opt_in_validation_phase: pick({
      en: "Participate in validation phase",
      es: "Participar en fase de validación",
      ca: "Participar en la fase de validació",
      eu: "Parte hartu balidazio-fasean",
      gl: "Participar na fase de validación",
      ar: "المشاركة في مرحلة التحقق",
      he: "השתתף בשלב האימות",
      zh: "参与验证阶段",
      it: "Partecipa alla fase di validazione",
      fr: "Participer à la phase de validation",
      de: "An Validierungsphase teilnehmen",
      "pt-br": "Participar da fase de validação",
      ja: "検証フェーズに参加する",
      hi: "सत्यापन चरण में भाग लें",
      ko: "검증 단계 참여",
      ru: "Участвовать в этапе валидации",
      cs: "Účastnit se validační fáze",
      nl: "Deelnemen aan validatiefase",
    }, lang),
    sport_level: pick({
      en: "Skill level",
      es: "Nivel de juego",
      ca: "Nivell d'habilitat",
      eu: "Trebetasun-maila",
      gl: "Nivel de habilidade",
      ar: "مستوى المهارة",
      he: "רמת מיומנות",
      zh: "技能等级",
      it: "Livello di abilità",
      fr: "Niveau de compétence",
      de: "Spielstärke",
      "pt-br": "Nível de habilidade",
      ja: "スキルレベル",
      hi: "कौशल स्तर",
      ko: "실력 수준",
      ru: "Уровень навыков",
      cs: "Úroveň dovedností",
      nl: "Vaardigheidsniveau",
    }, lang),
  },

  // ---- Empty states
  emptyActive: pick({
    en: "You haven't activated any apps yet. Browse below.",
    es: "Aún no activaste apps. Explora la lista de abajo.",
    ca: "Encara no has activat cap aplicació. Explora a continuació.",
    eu: "Oraindik ez duzu aplikaziorik aktibatu. Arakatu behean.",
    gl: "Aínda non activaches ningunha app. Explora abaixo.",
    ar: "لم تقم بتفعيل أي تطبيقات بعد. تصفح أدناه.",
    he: "עדיין לא הפעלת אף אפליקציה. עיין למטה.",
    zh: "您尚未激活任何应用。请浏览下方。",
    it: "Non hai ancora attivato alcuna app. Esplora qui sotto.",
    fr: "Vous n'avez encore activé aucune app. Parcourez ci-dessous.",
    de: "Sie haben noch keine Apps aktiviert. Stöbern Sie unten.",
    "pt-br": "Você ainda não ativou nenhum app. Navegue abaixo.",
    ja: "まだアプリをアクティベートしていません。以下をご覧ください。",
    hi: "आपने अभी तक कोई ऐप सक्रिय नहीं किया है। नीचे ब्राउज़ करें।",
    ko: "아직 활성화된 앱이 없습니다. 아래에서 둘러보세요.",
    ru: "Вы еще не активировали ни одного приложения. Посмотрите ниже.",
    cs: "Zatím jste neaktivovali žádné aplikace. Prohlédněte si je níže.",
    nl: "U heeft nog geen apps geactiveerd. Bekijk onderstaand aanbod.",
  }, lang),
  emptyAvailable: pick({
    en: "All apps activated — well done!",
    es: "Todas las apps activadas — ¡bien hecho!",
    ca: "Totes les aplicacions activades: bon fet!",
    eu: "Aplikazio guztiak aktibatuta — oso ondo!",
    gl: "Todas as apps activadas — moi ben!",
    ar: "تم تفعيل جميع التطبيقات — أحسنت!",
    he: "כל האפליקציות הופעלו — כל הכבוד!",
    zh: "所有应用已激活——做得好!",
    it: "Tutte le app attivate — ottimo lavoro!",
    fr: "Toutes les apps activées — bravo !",
    de: "Alle Apps aktiviert – gut gemacht!",
    "pt-br": "Todos os apps ativados — muito bem!",
    ja: "すべてのアプリがアクティベート済み — よくできました!",
    hi: "सभी ऐप सक्रिय हो गए — बहुत बढ़िया!",
    ko: "모든 앱 활성화 완료 — 잘하셨습니다!",
    ru: "Все приложения активированы — отлично!",
    cs: "Všechny aplikace aktivovány — skvělá práce!",
    nl: "Alle apps geactiveerd — goed gedaan!",
  }, lang),

  // Phase A6-prod (Feb 2026) — placeholder when HUB_CATALOG_ENDPOINT_ENABLED
  // is OFF (conservative Production posture). No catalog data is fetched;
  // no apps are activatable from this state.
  catalogDisabledTitle: pick({
    en: "App management coming soon",
    es: "La gestión de apps estará disponible próximamente",
    ca: "Gestió d'aplicacions disponible aviat",
    eu: "Aplikazioen kudeaketa laster eskuragarri",
    gl: "Xestión de apps próximamente",
    ar: "إدارة التطبيقات قريباً",
    he: "ניהול אפליקציות בקרוב",
    zh: "应用管理即将推出",
    it: "Gestione app in arrivo",
    fr: "Gestion des apps bientôt disponible",
    de: "App-Verwaltung demnächst verfügbar",
    "pt-br": "Gerenciamento de apps em breve",
    ja: "アプリ管理は近日公開",
    hi: "ऐप प्रबंधन जल्द आ रहा है",
    ko: "앱 관리 기능 곧 제공",
    ru: "Управление приложениями скоро появится",
    cs: "Správa aplikací již brzy",
    nl: "Appbeheer binnenkort beschikbaar",
  }, lang),
  catalogDisabledBody: pick({
    en: "We're rolling out HUB apps gradually. Active apps already in your account stay fully usable. New apps will appear here when they're ready.",
    es: "Estamos lanzando las apps del HUB de forma gradual. Las apps activas de tu cuenta siguen totalmente disponibles. Las nuevas aparecerán aquí cuando estén listas.",
    ca: "Estem desplegant les aplicacions del HUB gradualment. Les aplicacions actives que ja tens al compte segueixen funcionant completament. Les noves aplicacions apareixeran aquí quan estiguin a punt.",
    eu: "HUB aplikazioak pixkanaka zabaltzen ari gara. Zure kontuan dauden aplikazio aktiboak erabat erabilgarri geratzen dira. Aplikazio berriak hemen agertuko dira prest daudenean.",
    gl: "Estamos despregando as apps de HUB gradualmente. As apps activas que xa están na túa conta seguen sendo totalmente utilizables. As novas apps aparecerán aquí cando estean listas.",
    ar: "نقوم بطرح تطبيقات HUB تدريجياً. التطبيقات النشطة الموجودة بالفعل في حسابك تبقى قابلة للاستخدام بالكامل. ستظهر التطبيقات الجديدة هنا عندما تكون جاهزة.",
    he: "אנחנו משיקים את אפליקציות HUB בהדרגה. אפליקציות פעילות שכבר בחשבונך נשארות שמישות לחלוטין. אפליקציות חדשות יופיעו כאן כשהן מוכנות.",
    zh: "我们正在逐步推出HUB应用。您账户中已有的活跃应用仍可完全使用。新应用准备就绪后将显示在此处。",
    it: "Stiamo distribuendo le app HUB gradualmente. Le app attive già presenti nel tuo account restano completamente utilizzabili. Le nuove app appariranno qui quando saranno pronte.",
    fr: "Nous déployons progressivement les apps HUB. Les apps actives dans votre compte restent pleinement utilisables. De nouvelles apps apparaîtront ici dès qu'elles seront prêtes.",
    de: "Wir führen HUB-Apps schrittweise ein. Aktive Apps in Ihrem Konto bleiben vollständig nutzbar. Neue Apps erscheinen hier, sobald sie bereit sind.",
    "pt-br": "Estamos lançando os apps do HUB gradualmente. Apps ativos já na sua conta permanecem totalmente utilizáveis. Novos apps aparecerão aqui quando estiverem prontos.",
    ja: "HUBアプリは段階的に展開中です。アカウント内の既存のアクティブなアプリは完全に利用可能です。新しいアプリは準備が整い次第ここに表示されます。",
    hi: "हम HUB ऐप्स को धीरे-धीरे रोल आउट कर रहे हैं। आपके खाते में पहले से सक्रिय ऐप्स पूर्णतः उपयोग योग्य रहेंगे। नए ऐप्स जब तैयार होंगे तो यहां दिखाई देंगे।",
    ko: "HUB 앱을 단계적으로 출시하고 있습니다. 계정에 이미 있는 활성 앱은 계속 사용할 수 있습니다. 새 앱은 준비되는 대로 여기에 표시됩니다.",
    ru: "Мы постепенно внедряем приложения HUB. Активные приложения в вашей учетной записи остаются полностью доступными. Новые приложения появятся здесь, когда будут готовы.",
    cs: "Aplikace HUB zavádíme postupně. Aktivní aplikace ve vašem účtu zůstávají plně funkční. Nové aplikace se zde zobrazí, až budou připraveny.",
    nl: "We rollen HUB-apps geleidelijk uit. Actieve apps in uw account blijven volledig bruikbaar. Nieuwe apps verschijnen hier zodra ze gereed zijn.",
  }, lang),

  // ---- Loading / errors
  loading: pick({ en: "Loading apps…", es: "Cargando apps…", ca: "Carregant aplicacions…", eu: "Aplikazioak kargatzen…", gl: "Cargando apps…", ar: "جارٍ تحميل التطبيقات…", he: "טוען אפליקציות…", zh: "正在加载应用…", it: "Caricamento app…", fr: "Chargement des apps…", de: "Apps werden geladen…", "pt-br": "Carregando apps…", ja: "アプリを読み込み中…", hi: "ऐप्स लोड हो रहे हैं…", ko: "앱 로딩 중…", ru: "Загрузка приложений…", cs: "Načítání aplikací…", nl: "Apps laden…", }, lang),
  refresh: pick({ en: "Refresh", es: "Actualizar", ca: "Actualitza", eu: "Freskatu", gl: "Actualizar", ar: "تحديث", he: "רענן", zh: "刷新", it: "Aggiorna", fr: "Actualiser", de: "Aktualisieren", "pt-br": "Atualizar", ja: "更新", hi: "रीफ़्रेश करें", ko: "새로고침", ru: "Обновить", cs: "Obnovit", nl: "Vernieuwen", }, lang),
  saveFailed: pick({
    en: "Could not save. Try again.",
    es: "No se pudo guardar. Intenta de nuevo.",
    ca: "No s'ha pogut desar. Torna-ho a provar.",
    eu: "Ezin izan da gorde. Saiatu berriro.",
    gl: "Non se puido gardar. Téntao de novo.",
    ar: "تعذر الحفظ. حاول مرة أخرى.",
    he: "לא ניתן לשמור. נסה שוב.",
    zh: "无法保存。请重试。",
    it: "Impossibile salvare. Riprova.",
    fr: "Impossible d'enregistrer. Réessayez.",
    de: "Speichern fehlgeschlagen. Versuchen Sie es erneut.",
    "pt-br": "Não foi possível salvar. Tente novamente.",
    ja: "保存できませんでした。もう一度お試しください。",
    hi: "सहेजा नहीं जा सका। पुनः प्रयास करें।",
    ko: "저장할 수 없습니다. 다시 시도하세요.",
    ru: "Не удалось сохранить. Повторите попытку.",
    cs: "Uložení se nezdařilo. Zkuste to znovu.",
    nl: "Kon niet opslaan. Probeer het opnieuw.",
  }, lang),
});

export const useHubI18n = (lang) => _COPY(lang || "en");
export default _COPY;
